export default __webpack_public_path__ + "static/media/longBanner.d20eef37.svg";